import { render, staticRenderFns } from "./IconRegistry.vue?vue&type=template&id=38131d27"
import script from "./IconRegistry.vue?vue&type=script&lang=js"
export * from "./IconRegistry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports